(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.sione-header');
    if (!header) return;

    const toggle = header.querySelector('[data-sione-menu-toggle]');
    const drawer = header.querySelector('[data-sione-menu-drawer]');
    const closeBtn = header.querySelector('[data-sione-menu-close]');
    if (!toggle || !drawer) return;

    const openDrawer = () => {
      drawer.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
      });
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      const onEnd = () => {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
        }
        drawer.removeEventListener('transitionend', onEnd);
      };
      drawer.addEventListener('transitionend', onEnd);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        drawer.hidden = true;
      }
    };

    toggle.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-sione-product]').forEach((root) => {
    const mainImage = root.querySelector('.sione-product__main-image');
    const thumbs = root.querySelectorAll('[data-sione-product-thumb]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const full = thumb.dataset.full;
        if (mainImage && full) {
          mainImage.src = full;
          mainImage.removeAttribute('srcset');
        }

        thumbs.forEach((item) => item.removeAttribute('aria-current'));
        thumb.setAttribute('aria-current', 'true');
      });
    });

    const variantSelect = root.querySelector('[data-sione-variant-select]');
    const sellingPrice = root.querySelector('[data-sione-selling-price]');
    const comparePrice = root.querySelector('[data-sione-compare-price]');
    const discount = root.querySelector('[data-sione-discount]');
    const addButton = root.querySelector('[data-sione-add-button]');

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const selected = variantSelect.options[variantSelect.selectedIndex];

        if (sellingPrice && selected.dataset.price) {
          sellingPrice.textContent = selected.dataset.price;
        }

        if (comparePrice) {
          comparePrice.textContent = selected.dataset.compare || '';
          comparePrice.classList.toggle('is-hidden', !selected.dataset.compare);
        }

        if (discount) {
          discount.textContent = selected.dataset.discount || '';
          discount.classList.toggle('is-hidden', !selected.dataset.discount);
        }

        if (addButton) {
          const isAvailable = selected.dataset.available === 'true';
          addButton.disabled = !isAvailable;
          addButton.textContent = isAvailable ? addButton.dataset.availableText : addButton.dataset.soldOutText;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
